import { onView, onMount, onDestroy } from "@/modules/_";
import gsap from "@lib/gsap";

export default function (element: HTMLElement, dataset: DOMStringMap) {
  // const children = element.querySelectorAll("[data-fade-stagger]");

  gsap.set(element.children, {
    opacity: 0,
  });

  const observer = onView(element, {
    root: null,
    rootMargin: "0px",
    threshold: 0.2,
    autoStart: false,
    once: true,
    callback: ({ isIn }) => {
      if (isIn) {
        gsap.to(element.children, {
          opacity: 1,
          duration: 0.8,
          ease: "accelerate",
          stagger: 0.2,
        });
      }
    },
  });

  onMount(() => {
    observer.start();
  });

  onDestroy(() => {
    observer.destroy();
  });
}
